import React from "react";
import "./HoppersInputComponents.scss"

const HoppersTextArea = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {


    return (
        <div className="HoppersInputComponents-HoppersDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`HoppersInputComponents-HoppersDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <textarea
                    className="HoppersInputComponents-HoppersDefault-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default HoppersTextArea